import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {
	updateTicketCustomFieldValueMutation,
	UpdateCustomFieldValueInput,
} from './__generated__/updateTicketCustomFieldValueMutation.graphql';

const mutation = graphql`
	mutation updateTicketCustomFieldValueMutation($input: UpdateCustomFieldValueInput!) {
		updateCustomFieldValue(input: $input) {
			customFieldValue {
				node {
					__typename
					id
					key
					type
					displayName
					value
					displayValue
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: UpdateCustomFieldValueInput,
	onCompleted?: (r: updateTicketCustomFieldValueMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<updateTicketCustomFieldValueMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'updateTicketCustomFieldValueMutation'};
